// ** Overrides Imports
import Alerts from './alerts'
import button from "./button";
import card from "./card";
import Checkbox from "./checkbox";
import chip from './chip'
import DataGrid from './dataGrid'
import dialog from './dialog'
import iconButton from './icon-button'
import input from './input'
import list from './list';
import menu from './menu';
import paper from './paper'
import switchOverrides from './switches'
import tabs from './tabs'
import typography from './typography'
import Tooltip from './tooltip'

const Overrides = (mode) => {
  return Object.assign(
    Alerts,
    button,
    card(),
    Checkbox,
    chip,
    DataGrid(mode),
    dialog(),
    iconButton,
    input,
    list,
    menu(),
    paper,
    switchOverrides,
    tabs,
    typography,
    Tooltip
  )
}

export default Overrides;
